import React from 'react'
import Home from './Components/Home'
import './App.css'
import './Mobileapp.css'
import 'antd/dist/reset.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import About from './Components/About'
import Work from './Components/Work'
import Contact from './Components/Contact'
import { ParallaxProvider } from 'react-scroll-parallax';
import ScrollToTop from './ScrollToTop';

const App = () => {
  return (
    <ParallaxProvider>
      <BrowserRouter>
        <ScrollToTop /> {/* This makes the page go to top on route change */}

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work" element={<Work />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

      </BrowserRouter>
    </ParallaxProvider>
  )
}

export default App